import { USE_HTTPONLY_ONLY } from '../config/authConfig';

/**
 * Token to send in API request body/query. Returns '' when using HttpOnly-only auth.
 */
export function getTokenForRequest() {
  if (USE_HTTPONLY_ONLY) return '';
  if (typeof window !== 'undefined' && window.CheckSessionToken) {
    const t = window.CheckSessionToken();
    if (t) return t;
  }
  try {
    const match = document.cookie.split(';').find(row => row.trim().startsWith('token='));
    return match ? (match.split('=')[1]?.trim() || '') : '';
  } catch (_) { return ''; }
}
